<div class="container px-0">
  <div class="row">
    <div class="col-12 text-right">
      <div class="choices-container scrollbar-minimal">
        @for (choice of message.Payload.Choices; track choice) {
          <button class="btn btn-round" [class.btn-sm]="message.Payload.Choices.length > 3" [disabled]="!choice.Checked && lockRemainingChoices" [class.btn-secondary]="!choice.Checked" [class.btn-dark]="choice.Checked" (click)="choiceClicked(choice);">
            {{choice.Label}}
          </button>
        }
      </div>
    </div>
  </div>
  @if (message.Payload.MaximumSelectedChoices > 1) {
    <div class="row align-items-end">
      <div class="col">
        @if (getDefactoMaxOptions() > 1 && getSelectedCount() == 0) {
          <small class="col footnote text-muted">Wähle bis zu {{ getDefactoMaxOptions() }} Optionen</small>
        }
        @if (getDefactoMaxOptions() > 1 && getSelectedCount() > 0 && getSelectedCount() < getDefactoMaxOptions()) {
          <small class="col footnote text-muted">{{ getSelectedCount() }}/{{ getDefactoMaxOptions() }} ausgewählt</small>
        }
        @if (getDefactoMaxOptions() > 1 && getSelectedCount() == getDefactoMaxOptions()) {
          <small class="col footnote text-muted">Maximale Anzahl an Optionen ausgewählt</small>
        }
      </div>
      <div class="col-auto mt-3">
        <button class="btn btn-dark btn-circle send-button" [disabled]="getSelectedCount() < message.Payload.MinimumSelectedChoices" (click)="send()">
          <i class="fa-sharp fa-solid fa-paper-plane-top"></i>
        </button>
      </div>
    </div>
  }
</div>